import React from 'react';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IconProfile } from '../../images/icn_profilo.svg';
import { Col, CustomInput, FormGroup, Row } from 'reactstrap';
import SearchInput from '../../commons/SearchInput';
import Footer from '../../commons/Footer';
import { ContPaginationPage } from '../../styled-components';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import OfficesTable from './OfficesTable';
import { useAuth } from '../../commons/Auth';
import ExportCSVButton from './ExportCSVButton';

const OfficesPresentational = ({ profile, data, formattedData, total, query, onFilter }) => {
  const [t] = useTranslation('OFFICES');
  const [{ newIsAdmin } = {}] = useAuth();
  const { offset, limit } = query;

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:OFFICES')}
            icon={<IconProfile fill="#ffffff" style={{ height: '25px' }} />}
          />

          <Row className="align-items-center">
            <Col xs={12} style={{ marginBottom: 30 }}>
              <ExportCSVButton data={formattedData} />
            </Col>
          </Row>

          <Row style={{ rowGap: '1rem' }}>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.code }}
                onFilter={({ search }) => onFilter({ code: search })}
                label={t('CODE')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.office }}
                onFilter={({ search }) => onFilter({ office: search })}
                label={t('OFFICE')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.businessName }}
                onFilter={({ search }) => onFilter({ businessName: search })}
                label={t('BUSINESS_NAME')}
              />
            </Col>

            {newIsAdmin ||
              (profile.type !== 'ASSOCIATION' && (
                <Col sm="6" md="6" lg="3" xl="3">
                  <SearchInput
                    query={{ search: query && query.associationSearch }}
                    onFilter={({ search }) =>
                      onFilter({ associationSearch: search })
                    }
                    label={t('ASSOCIATION_SEARCH')}
                  />
                </Col>
              ))}

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.email }}
                onFilter={({ search }) => onFilter({ email: search })}
                label={t('EMAIL')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.address }}
                onFilter={({ search }) => onFilter({ address: search })}
                label={t('ADDRESS')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.contactPerson }}
                onFilter={({ search }) => onFilter({ contactPerson: search })}
                label={t('CONTACT_PERSON')}
              />
            </Col>
          </Row>
        </section>

        <section className="m-t-20">
          <OfficesTable
            profile={profile}
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default OfficesPresentational;
